import InterceptCheckoutComplete from "./interceptCheckoutComplete";

export default InterceptCheckoutComplete;
